<template>
  <v-container class="mb-8">
    <!-- Back Button -->
    <v-btn text small class="px-1" @click="$router.go(-1)"
      ><v-icon left small> mdi-chevron-left </v-icon
      >{{ $langs.Gen.goBack[$langs.lang] }}</v-btn
    >

    <v-card tile class="mt-3 py-6 px-6">
      <v-row>
        <v-col cols="12" md="6" class="">
          <v-img
            class="mx-auto"
            width="540"
            src="@/assets/img/About_Us2.png"
          ></v-img>
        </v-col>

        <v-col cols="12" md="6" class="px-3">
          <h1 class="text-center text-h5 font-weight-medium primary--text">
            เกี่ยวกับเรา
          </h1>

          <div class="mt-3">
            <span class="mr-8"></span>
            Marketpett เป็น Platform
            สำหรับซื้อขายสัตว์เลี้ยงและอุปกรณ์สำหรับสัตว์เลี้ยง
            โดยจุดเริ่มต้นมาจาก ทีม Startup
            ของนิสิตมหาวิทยาลัยเกษตรศาสตร์ที่หลงรักในการเลี้ยงสัตว์
            และเพาะพันธุ์สัตว์เลี้ยง โดยผ่านการแข่งขันในรายการ True startup
            challenge 2020, KU startup league และ Startup thailand league
            โดยทางเราอยากจะช่วยเพิ่มศักยภาพ
            และเติบโตไปพร้อมกับผู้ประกอบการที่เกี่ยวข้องกับธุรกิจสัตว์เลี้ยง
            <span style="white-space: nowrap"
              >" For Breeders By Breeders "</span
            >
          </div>

          <div class="text-center mt-3">
            <v-btn
              href="https://www.ku.ac.th/web-upload/202008/m_news/339/434/file_download/ca56b7b5538ce8acf9703d68d4f095df.pdf"
              target="_blank"
              color="primary"
              text
              :ripple="false"
              >ตัวอย่างความสำเร็จอันเล็กน้อย</v-btn
            >
          </div>

          <div class="mt-12 px-3">
            <v-divider></v-divider>
          </div>

          <div class="mt-3 font-weight-medium text-center">
            ติดต่อเรา
          </div>
          <div class="text-center text-caption">
            <div>Facebook: <a class="link" href="https://www.facebook.com/Marketpett.official" target="_black">Marketpett.official</a></div>
            <div>Instagram: <a class="link" href="https://www.instagram.com/marketpett_" target="_black">marketpett_</a></div>
            <div>Twitter: <a class="link" href="https://twitter.com/marketpett_twt" target="_black">@marketpett_twt</a></div>
            <div>Email: contact.marketpett@gmail.com</div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {};
</script>

<style>
</style>